export const modalTypes = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
